import { apiService } from './axios.client';

export const RoadwayEndPoints = {
	getQO: function (input, callback) {
		apiService.post('/roadway/getQO', input.postObject)
			.then((response) => callback(response, input.props))
			.catch(error => alert(error.response.data.message));
	}
}